'use strict';

/**
 * Base Font Weight:
 *
 * Empty object by default. Font weights are tied to font CSS and .woff files.
 * FontWeight plugin creates dynamic utility class for each font used.
 */ const fontWeight = {};

exports.fontWeight = fontWeight;
//# sourceMappingURL=fontWeight.js.map
